import moment from "moment";

export function formatDateDDMMYYYY(date: string): string {
  return moment(date).format("DD/MM/YYYY");
}
